module.exports = __webpack_public_path__ + "static/img/SketchPng10643c768037a78215c4e0083b4f767d707bac39c0e133daf733d8823cc85bce.902bdae8.png";